import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoyaltyProgramPage from "./loyalty-program.page";
import {
  AccessRights
} from "lib/constants/accessRights";
import { useHistory } from "react-router-dom";
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import { ROOT } from "modules/loyalty-program";
import { useLocation } from "react-router-dom";
import qs from "query-string";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function LoyaltyProgramPageContainer() {
  const history = useHistory()
  const hasLoyaltyProgramAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.MODULE));
  const hasLoyaltyProgramViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.LOYALTY_POINT_READ));
  const hasLoyaltyProgramAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.LOYALTY_POINT_WRITE_CREATE));
  const hasBonanzaViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.BONANZA_READ));
  const hasBonanzaAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.BONANZA_WRITE_CREATE));
  const hasGiftViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.GIFT_READ));
  const hasGiftAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.GIFT_WRITE_CREATE));
  const hasGiftRedemptionViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.GIFT_REDEMPTION_READ));
  const hasPointCutViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.POINT_CUT_READ));
  const hasPointCutAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.LoyaltyProgram.POINT_CUT_WRITE_CREATE));
  const lang = useSelector(state => state.constant.languages);
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();

  const qsParams = qs.parse(location.search);
  const currentSearch = qsParams.tab || '';

  const tabs = [];
  let index = 0;
  if (hasLoyaltyProgramViewAccessRight) {
    tabs.push({
      label: getLang(lang,"label.LOYALTY_POINT_TAB"),
      tabName: "loyaltyPoint",
      enabled: hasLoyaltyProgramViewAccessRight,
      value: index++,
    });
  }
  if (hasBonanzaViewAccessRight) {
    tabs.push({
      label: getLang(lang,"label.BONANZA_TAB"),
      tabName: "bonanza",
      enabled: hasBonanzaViewAccessRight,
      value: index++,
    });
  }
  if (hasGiftViewAccessRight) {
    tabs.push({
      label: getLang(lang,"label.GIFT_LIST_TAB"),
      tabName: "giftList",
      enabled: hasGiftViewAccessRight,
      value: index++,
    });
  }
  if (hasGiftRedemptionViewAccessRight) {
    tabs.push({
      label: getLang(lang,"label.GIFT_REDEMPTION_TAB"),
      tabName: "redemption",
      enabled: hasGiftRedemptionViewAccessRight,
      value: index++,
    });
  }
  if (hasPointCutViewAccessRight) {
    tabs.push({
      label: getLang(lang,"label.POINTS_CUT_TAB"),
      tabName: "pointCut",
      enabled: hasPointCutViewAccessRight,
      value: index++,
    });
  }

  useEffect(() => {
    if (!hasLoyaltyProgramAccessRight) {
      history.push('/admin/dashboard')
    }
  }, [history, hasLoyaltyProgramAccessRight])

  useEffect(() => {
    let tempIndex = tabs.find(e => e.tabName === currentSearch)?.value ?? tabs[0].value;
    setActiveIndex(tempIndex);
  }, [currentSearch, tabs])

  if (!hasLoyaltyProgramAccessRight) return <LoadingComponent />;

  const handleChange = (event, index) => {
    setActiveIndex(index);
    const name = tabs[index].tabName ?? tabs[0].tabName
    history.replace({
      pathname: ROOT,
      search: `?tab=${name}`
    })
  };

  return (
    <LoyaltyProgramPage
      hasLoyaltyProgramViewAccessRight={hasLoyaltyProgramViewAccessRight}
      hasLoyaltyProgramAddAccessRight={hasLoyaltyProgramAddAccessRight}
      hasBonanzaViewAccessRight={hasBonanzaViewAccessRight}
      hasBonanzaAddAccessRight={hasBonanzaAddAccessRight}
      hasGiftViewAccessRight={hasGiftViewAccessRight}
      hasGiftAddAccessRight={hasGiftAddAccessRight}
      hasGiftRedemptionViewAccessRight={hasGiftRedemptionViewAccessRight}
      hasPointCutViewAccessRight={hasPointCutViewAccessRight}
      hasPointCutAddAccessRight={hasPointCutAddAccessRight}
      handleChange={handleChange}
      activeIndex={activeIndex}
      tabLabels={tabs.map(e => e.label)}
      lang={lang}
    />
  );
}

export default LoyaltyProgramPageContainer;
